export enum SharedOrderText {
  scanQR = 'Scan QR code or copy and share this link with the members of your party so they can add their items to the shared order! Please note you are the owner of this tab, the only one who can place orders and make payment.',
  modalMain = 'Hello! Would you like to create a shared order with your party?',
  receiveNumber = 'If you would like to receive a text message when someone adds an order to the shared order, please fill in your phone number.'
}
